var _defs, _polygon, _circle, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCoverPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6ed3e2c-62f7-4fcf-8641-e69606654f8b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a46f93ee-1240-4390-902e-2075fb534810{opacity:0.2;}.f6b29046-0e77-4d6e-84e6-bc4fa762f3f8{fill:#333;}.ada7c72c-b6d4-442e-bd57-0912bf06bc72{fill:#303030;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-rounded-add-cover-photo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26 25 22 19 19 23 17 21 14 25 26 25"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a46f93ee-1240-4390-902e-2075fb534810"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f6b29046-0e77-4d6e-84e6-bc4fa762f3f8",
    d: "M35,.5A4.50509,4.50509,0,0,1,39.5,5V35A4.50509,4.50509,0,0,1,35,39.5H5A4.50509,4.50509,0,0,1,.5,35V5A4.50509,4.50509,0,0,1,5,.5H35M35,0H5A5,5,0,0,0,0,5V35a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ada7c72c-b6d4-442e-bd57-0912bf06bc72",
    d: "M32,17H30V15a1,1,0,0,0-2,0v2H26a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V19h2a1,1,0,0,0,0-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ada7c72c-b6d4-442e-bd57-0912bf06bc72",
    d: "M27.5,26a.50057.50057,0,0,1-.5.5H13a.50057.50057,0,0,1-.5-.5V14a.50057.50057,0,0,1,.5-.5H26.41736A3.00236,3.00236,0,0,1,27.891,12.2182,1.9787,1.9787,0,0,0,27,12H13a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V24a2.96516,2.96516,0,0,1-1.5-.41736Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCoverPhoto);
export default __webpack_public_path__ + "static/media/add-cover-photo.44e1f2cef71337ed11a2a0a15e45c4d8.svg";
export { ForwardRef as ReactComponent };